export default __webpack_public_path__ + "static/media/push-pin 2.8e077030.svg";